export { default } from './GraficBarres';
